<template>
  <span>{{ category }}</span>
</template>
<script>
import { PLOT_CHILD_CATEGORY } from "@/config/const";
export default {
  name: "CellRendererPlotCategory",
  data() {
    return {
      noValue: "-",
    };
  },
  computed: {
    category() {
      return this.params.value != null
        ? PLOT_CHILD_CATEGORY.properties[this.params.value].label
        : this.noValue;
    },
  },
};
</script>

<style lang="scss" scoped></style>
